import Carousel from "react-bootstrap/Carousel";
import { Link } from "react-router-dom";
import "./CustomCarousel.css";
import { resolveAssetUrl } from "../utils/assets";

function HomeCarousel({ data }) {
  const items = data?.items || [];
  const interval = data?.intervalMs || 3000;

  if (!items.length) return null;

  return (
    <div className="custom-carousel-container">
      <Carousel
        slide
        fade={false}
        interval={interval}
        pause={false}
        indicators
        controls
      >
        {items.map((slide, index) => {
          const imageSrc =
            resolveAssetUrl(slide.image) || slide.image || "";
          const link = slide.link || "/products";

          return (
            <Carousel.Item key={index}>
              <div
                className="carousel-slide"
                style={{
                  backgroundImage: imageSrc ? `url(${imageSrc})` : undefined,
                }}
              >
                {slide.buttonText && (
                  <Link to={link.startsWith("/") ? link : `/${link}`} className="shop-now-btn">
                    {slide.buttonText}
                  </Link>
                )}
              </div>
            </Carousel.Item>
          );
        })}
      </Carousel>
    </div>
  );
}

export default HomeCarousel;
